import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Beat } from "../../../plugins/spinners.plugin";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import Warning from "../../../assets/images/icons/warning.svg";
import { filterRestaurantOrderAction } from "../../../redux/restaurantOrder/restaurantOrderActions";
import { getOutletFromCookies, getTeamFromCookies } from "../../../utils/Auth";

export default function FilterRestaurantOrdersDropDown(props) {
  const { payLoad, isFilterOpen, setFilterState } = props;
  const dispatch = useDispatch();
  const outlet = getOutletFromCookies();
  const team = getTeamFromCookies();
  const { filtering } = useSelector((state) => state.restaurantOrder);
  const { page } = useParams();

  const [errorMsg, setErrorMsg] = useState(false);
  const [couponInput, setCouponInput] = useState("");
  const [promoInput, setPromoInput] = useState("");
  const [data, setData] = useState({
    business_id: "",
    restaurant_id: "",
    recipient_name: "",
    recipient_phone: "",
    recipient_email: "",
    recipient_address: "",
    recipient_city: "",
    recipient_state: "",
    recipient_country: "",
    start_date: "",
    end_date: "",
    order_amount: "",
    order_paid: "",
    order_payment_confirmed: "",
    order_service_fee: "",
    order_delivery_fee: "",
    order_currency: "",
    status: payLoad?.status,
    order_coupons: [],
    order_promotion_codes: [],
  });
  const {
    business_id,
    restaurant_id,
    recipient_name,
    recipient_phone,
    recipient_email,
    recipient_address,
    recipient_city,
    recipient_state,
    recipient_country,
    start_date,
    end_date,
    order_amount,
    order_paid,
    order_payment_confirmed,
    order_service_fee,
    order_delivery_fee,
    order_currency,
    order_coupons,
    order_promotion_codes,
  } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleAddCoupon = () => {
    if (couponInput.trim()) {
      setData((prevData) => ({
        ...prevData,
        order_coupons: [...(prevData.order_coupons || []), couponInput.trim()],
      }));
      setCouponInput("");
    }
  };

  const handleRemoveCoupon = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    setData((prevData) => ({
      ...prevData,
      order_coupons: (prevData.order_coupons || []).filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handleCouponInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddCoupon();
    }
  };

  const handleAddPromo = () => {
    if (promoInput.trim()) {
      setData((prevData) => ({
        ...prevData,
        order_promotion_codes: [
          ...(prevData.order_promotion_codes || []),
          promoInput.trim(),
        ],
      }));
      setPromoInput("");
    }
  };

  const handleRemovePromo = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    setData((prevData) => ({
      ...prevData,
      order_promotion_codes: (prevData.order_promotion_codes || []).filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handlePromoInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddPromo();
    }
  };

  const handleReset = async () => {
    setData({
      business_id: "",
      restaurant_id: "",
      recipient_name: "",
      recipient_phone: "",
      recipient_email: "",
      recipient_address: "",
      recipient_city: "",
      recipient_state: "",
      recipient_country: "",
      start_date: "",
      end_date: "",
      order_amount: "",
      order_paid: "",
      order_payment_confirmed: "",
      order_service_fee: "",
      order_delivery_fee: "",
      order_currency: "",
      status: payLoad?.status,
      order_coupons: [],
      order_promotion_codes: [],
    });
    await dispatch(
      filterRestaurantOrderAction({ ...payLoad, pagination: 1 }, page)
    );
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    let newData = { ...data };
    if (team !== "administrator") {
      newData.business_id = outlet?.business_id;
      newData.restaurant_id = outlet?.id;
    }
    if (
      business_id ||
      restaurant_id ||
      recipient_name ||
      recipient_phone ||
      recipient_email ||
      recipient_address ||
      recipient_city ||
      recipient_state ||
      recipient_country ||
      order_amount ||
      order_paid ||
      order_service_fee ||
      order_delivery_fee ||
      order_currency ||
      order_payment_confirmed ||
      start_date ||
      end_date ||
      order_coupons?.length > 0 ||
      order_promotion_codes?.length > 0
    ) {
      setErrorMsg(false);
      try {
        const response = await dispatch(
          filterRestaurantOrderAction(newData, 1)
        );
        if (response?.status === "success") {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div data-test="">
      <form className="py-5 mt-4 px-5">
        <div className="grid grid-cols-1">
          <Input.Label
            title={"Business Id"}
            htmlFor={"business_id"}
            name={"business_id"}
            onChange={handleChange}
            value={business_id}
            autoComplete="off"
            placeholder={"Enter Business Id"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Restaurant Id"}
            htmlFor={"restaurant_id"}
            name={"restaurant_id"}
            onChange={handleChange}
            value={restaurant_id}
            autoComplete="off"
            placeholder={"Enter Restaurant Id"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Customer Name"}
            htmlFor={"recipient_name"}
            name={"recipient_name"}
            onChange={handleChange}
            value={recipient_name}
            autoComplete="off"
            placeholder={"Enter Restaurant Name"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Number
            title={"Customer Phone"}
            htmlFor={"recipient_phone"}
            name={"recipient_phone"}
            onChange={handleChange}
            value={recipient_phone}
            autoComplete="off"
            placeholder={"Enter Customer Phone"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Customer Email"}
            htmlFor={"recipient_email"}
            name={"recipient_email"}
            onChange={handleChange}
            value={recipient_email}
            autoComplete="off"
            placeholder={"Enter Restaurant Email"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Customer Address"}
            htmlFor={"recipient_address"}
            name={"recipient_address"}
            onChange={handleChange}
            value={recipient_address}
            autoComplete="off"
            placeholder={"Enter Restaurant Address"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Customer City"}
            htmlFor={"recipient_city"}
            name={"recipient_city"}
            onChange={handleChange}
            value={recipient_city}
            autoComplete="off"
            placeholder={"Enter Customer City"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Customer State"}
            htmlFor={"recipient_state"}
            name={"recipient_state"}
            onChange={handleChange}
            value={recipient_state}
            autoComplete="off"
            placeholder={"Enter Customer State"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Customer Country"}
            htmlFor={"recipient_country"}
            name={"recipient_country"}
            onChange={handleChange}
            value={recipient_country}
            autoComplete="off"
            placeholder={"Enter Customer Country"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Number
            title={"Order Amount"}
            htmlFor={"order_amount"}
            name={"order_amount"}
            onChange={handleChange}
            value={order_amount}
            autoComplete="off"
            placeholder={"Enter Order Amount"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Number
            title={"Order Service Fee"}
            htmlFor={"order_service_fee"}
            name={"order_service_fee"}
            onChange={handleChange}
            value={order_service_fee}
            autoComplete="off"
            placeholder={"Enter Order Service Fee"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Number
            title={"Order Delivery Fee"}
            htmlFor={"order_delivery_fee"}
            name={"order_delivery_fee"}
            onChange={handleChange}
            value={order_delivery_fee}
            autoComplete="off"
            placeholder={"Enter Order Delivery Fee"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Label
            title={"Order Currency"}
            htmlFor={"order_currency"}
            name={"order_currency"}
            onChange={handleChange}
            value={order_currency}
            autoComplete="off"
            placeholder={"Enter Order Currency"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
          />

          <Input.Select
            title={"Order Paid"}
            htmlFor={"order_paid"}
            name={"order_paid"}
            value={order_paid}
            onChange={handleChange}
          >
            <option>Select payment status</option>
            <option value={"1"}>Paid</option>
            <option value={"0"}>Unpaid</option>
          </Input.Select>

          <Input.Select
            title={"Order Payment Confirmed"}
            htmlFor={"order_payment_confirmed"}
            name={"order_payment_confirmed"}
            value={order_payment_confirmed}
            onChange={handleChange}
          >
            <option>Select order confirmation status</option>
            <option value={"1"}>True</option>
            <option value={"0"}>False</option>
          </Input.Select>

          {/* Add Coupons */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-[#151515] dark:text-white">
              Order Coupons
            </label>
            <div className="mt-2 flex gap-2">
              <input
                type="text"
                value={couponInput}
                onChange={(e) => setCouponInput(e.target.value)}
                onKeyDown={handleCouponInputKeyDown}
                placeholder="Enter coupon code"
                className="flex-1 block pl-3 pr-10 text-base bg-[#FFFFFF] dark:bg-[transparent] focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 border border-gray-300 rounded-sm"
              />
              <button
                type="button"
                onClick={handleAddCoupon}
                className="px-4 py-2 bg-red-600 text-white text-sm rounded-sm hover:bg-red-700 focus:outline-none h-[40px]"
              >
                Add
              </button>
            </div>
            {order_coupons?.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-2">
                {order_coupons.map((coupon, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full"
                  >
                    <span className="text-sm text-[#151515] dark:text-white">
                      {coupon}
                    </span>
                    <button
                      type="button"
                      onClick={(e) => handleRemoveCoupon(e, index)}
                      className="text-red-600 hover:text-red-800 focus:outline-none"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Add Promotion Codes */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-[#151515] dark:text-white">
              Order Promotion Codes
            </label>
            <div className="mt-2 flex gap-2">
              <input
                type="text"
                value={promoInput}
                onChange={(e) => setPromoInput(e.target.value)}
                onKeyDown={handlePromoInputKeyDown}
                placeholder="Enter promotion code"
                className="flex-1 block pl-3 pr-10 text-base bg-[#FFFFFF] dark:bg-[transparent] focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 border border-gray-300 rounded-sm"
              />
              <button
                type="button"
                onClick={handleAddPromo}
                className="px-4 py-2 bg-red-600 text-white text-sm rounded-sm hover:bg-red-700 focus:outline-none h-[40px]"
              >
                Add
              </button>
            </div>
            {order_promotion_codes?.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-2">
                {order_promotion_codes.map((promo, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full"
                  >
                    <span className="text-sm text-[#151515] dark:text-white">
                      {promo}
                    </span>
                    <button
                      type="button"
                      onClick={(e) => handleRemovePromo(e, index)}
                      className="text-red-600 hover:text-red-800 focus:outline-none"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <Input.DatePicker
            title={"Start Date"}
            name="start_date"
            id="start_date"
            htmlFor={"start_date"}
            defaultValue={start_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
          <Input.DatePicker
            title={"End Date"}
            name="end_date"
            id="end_date"
            htmlFor={"end_date"}
            defaultValue={end_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
        </div>
        <div className="py-8 grid grid-cols-2 gap-6 text-center">
          <Button.Secondary
            disabled={filtering}
            title={"Reset"}
            className="px-4"
            onClick={handleReset}
            type="button"
          />
          <Button.Primary
            disabled={filtering}
            title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
            className="px-4"
            onClick={handleSubmit}
            type="button"
          />
        </div>
        {errorMsg && (
          <div className="flex gap-1 -mt-2">
            <img src={Warning} alt="warning" />
            <p>No value to filter by</p>
          </div>
        )}
      </form>
    </div>
  );
}
